// This is an auto-generated file. Do not edit it directly — your changes will be overwritten the next time the model configs are generated.

 import type { ParkingSpot } from '@pigello/pigello-matrix';


import { useGetInstance, useGetList } from '@/requests/hooks';

import type {
  useGetGenericInstanceProps,
  useGetGenericListProps,
} from '@/requests/types';


export const useGetParkingSpot = (
  options: useGetGenericInstanceProps<ParkingSpot>
) => {
  return useGetInstance<ParkingSpot>({
    ...options,
    modelName: 'parkingspot'
  });
};

export const useGetParkingSpotList = (
  options: useGetGenericListProps<ParkingSpot>
) => {
  return useGetList<ParkingSpot>({
    ...options,
    modelName: 'parkingspot'
  });
};
